<template>
  <div>
    <div class="vx-row">
      <div class="container-fluid">
        <div class="row mt-base" style="margin-bottom:50px;">
          <div class="col-md-6">
            <div class="container-fluid">
              <div class="row justify-content-center align-items-center">
                <div class="col-md-6">
                  <vs-button :disabled="status" @click="clear">{{$t('clear')}}</vs-button>
                </div>
                <div class="col-md-6">
                  <label
                    class="btn mt-3"
                    style="background-color:#7367F0;color:white;border-radius:15px;"
                  >
                    <i class="fa fa-image"></i>
                    {{$t('selectPhoto')}}
                    <input
                      style="display: none;"
                      id="uploader"
                      accept=".jpg, .png, .jpeg"
                      type="file"
                      multiple
                      :name="$t('selectPhoto')"
                      v-on:change="upload"
                    />
                  </label>
                </div>
              </div>
              <div class="row justify-content-center align-items-center">
                <div class="col-md-12">
                  <vs-list v-if="photos.length > 0">
                    <vs-list-header :title="$t('photos')" color="primary"></vs-list-header>
                    <draggable :list="photos" class="p-2 cursor-move">
                      <transition-group>
                        <vs-list-item
                          class="list-item"
                          v-for="(item, index) in photos"
                          :key="index"
                          :title="$t('photo')+ ' ' + (parseInt(index) + parseInt(1))"
                        >
                          <div class="container-fluid">
                            <div class="row justify-content-around aligns-item-center">
                              <div class="col-2 ortalama" style="height:100px;">
                                <feather-icon
                                  class="cursor-pointer color"
                                  icon="TrashIcon"
                                  svgClasses="h-6 w-6"
                                  @click="removeImage(index)"
                                />
                              </div>
                              <div class="col-10 ortalama" style="width:150px;height:100px;">
                                <img class="img-fluid" height="100px" :src="item.img" alt />
                              </div>
                            </div>
                          </div>
                        </vs-list-item>
                      </transition-group>
                    </draggable>
                  </vs-list>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="container-fluid">
              <div class="row justify-content-center align-items-center">
                <div class="col-md-12">
                  <h3>{{$t('frameCount')}}: {{count}}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  props: ["count", "status", "photos"],
  data() {
    return {};
  },
  methods: {
    clear() {
      this.$emit("clear");
    },
    removeImage(index) {
      this.$emit("removeImage", index);
    },
    upload(event) {
      this.$emit("upload", event);
    },
  },
};
</script>

<style scoped>
.ortalama {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.color {
  color: red;
}
.list-item {
  transition: all 1s;
}

input[type="file"] {
  cursor: pointer !important;
  font: 300 14px sans-serif;
  color: #9e9e9e;
}
input[type="file"]::-webkit-file-upload-button {
  font: 300 14px sans-serif;
  background: #7367f0;
  border: 0;
  padding: 12px 25px;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
  border-radius: 30px;
}

input[type="file"]::-ms-browse {
  font: 300 14px "Roboto", sans-serif;
  background: #7367f0;
  border: 0;
  padding: 12px 25px;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
}
</style>